import React from 'react';
export function AIActPage() {
  return <div className="min-h-screen bg-[#121212]" data-id="element-1342">
      <div className="pt-6 px-4 md:px-8 pb-4" data-id="element-1343">
        <h1 className="text-[20px] font-semibold text-white tracking-tight" data-id="element-1344">
          AI Act Compliance
        </h1>
      </div>
    </div>;
}